import React, { useContext, useState } from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { CaretRight, List, Phone, CaretDown, X } from 'phosphor-react'
import QuoteFormContext from '../context/QuoteFormContext'
import SlideMenuContext from '../context/SlideMenuContext'
import flatListToHierarchical from '../helpers/menu'
import Logo from './Logo'
import { useLocation } from '@reach/router'

const Navbar = () => {
  const data = useStaticQuery(graphql`
    query MainMenuQuery {
      wpMenu(name: { eq: "Main Menu" }) {
        name
        menuItems {
          nodes {
            url
            id
            label
            parentId
          }
        }
      }
    }
  `)

  const { toggleModal } = useContext(QuoteFormContext)
  const { toggleMenu } = useContext(SlideMenuContext)
  const navItems = flatListToHierarchical(data.wpMenu.menuItems.nodes)
  const [isPhoneDropdownOpen, setIsPhoneDropdownOpen] = useState(false)
  const location = useLocation();

  const isCommercialPages = location.pathname.includes('commercial-auto-lease');

  let navClassName = 'sticky top-0 navbar flex w-full px-6 md:px-10 lg:px-20 h-24 bg-brand-blue text-white items-center justify-between z-20';
  if (isCommercialPages) {
    navClassName += ' commercial-page';
  }


  return (
    <nav className={navClassName}>
      <div className="items-center flex">
        <div className="flex-shrink-0 md:mr-16 flex items-center">
          <List
            size={32}
            onClick={() => toggleMenu()}
            className="hamburger mr-4 lg:hidden cursor-pointer"
          />

          <Link to="/" className="navbar-item">
            <img
              src="/dm-white.svg"
              alt="d&m logo"
              className="w-3/4 md:w-full logo-img"
            />
          </Link>
        </div>
        <div className="nav-items hidden md:hidden lg:flex justify-start flex-nowrap overflow-hidden">
          {navItems.map((menuItem, index) => (
            <>
              <Link
                className={
                  'block relative ' 
                  + (menuItem.url === '#more' ? 'mr-2 ' : 'mr-4 ')
                  + (index == 2 ? 'md:hidden xl:block' : (index == 3 || index == 4 ? 'md:hidden show-on-1480' : ''))
                }
                to={menuItem.url}
                key={menuItem.id}
                onClick={() => menuItem.url === '#more' && toggleMenu()}
              >
                <div className="group inline-block relative">
                  <span className="group relative uppercase nav-item break-none hover:underline flex justify-between items-center gap-x-2">
                    {menuItem.label}
                    {menuItem.children.length ? (
                      <CaretDown weight="bold" />
                    ) : null}
                  </span>
                  <div className="fixed hidden pt-1 group-hover:block shadow-md z-20">
                    {menuItem.children.map(menuItemChild => (
                      <Link
                        key={menuItemChild.id}
                        className="bg-white hover:bg-gray-100  p-4 block whitespace-no-wrap text-gray-600"
                        to={menuItemChild.url}
                      >
                        {menuItemChild.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </Link>

              {menuItem.url === '#more' && (
                <List
                  size={32}
                  onClick={() => toggleMenu()}
                  className="hamburger pb-2 cursor-pointer"
                />
              )}
            </>
          ))}
        </div>
      </div>

      <div className="flex flex-row-reverse md:flex-row transition-all items-center md:flex-shrink-0 gap-x-2 md:gap-x-5">
        <button
          className="btn md:hidden cursor-pointer contact-us"
          type="button"
          onClick={() => setIsPhoneDropdownOpen(!isPhoneDropdownOpen)}
        >
          <Phone size={20} weight="fill" className="md:hidden" />
        </button>
        <Link to="/contact-us/" className="hidden md:block btn contact-us">
          <span className="">
            <span className="hidden md:block">Contact Us</span>
          </span>
        </Link>

        <button className="btn" type="button" onClick={() => toggleModal()}>
          <span className="md:hidden text-xs">quote</span>
          <span className="hidden md:block"> Get a quote</span>
        </button>
      </div>

      {isPhoneDropdownOpen && (
        <div
          className="fixed top-24 right-0 left-0"
          style={{ backgroundColor: '#383838' }}
        >
          <div className="h-full w-full">
            <table className="w-full">
              <tbody>
                <tr className="top">
                  <td className="w-1/2 text-center p-0 phone-btn">
                    <a
                      href="tel:(972) 355-3273"
                      className="p-4 flex flex-col items-center justify-center cursor-pointer  border-t-0"
                    >
                      <p className="block text-xs">Call</p>
                      <p>D&M Dallas</p>
                    </a>
                  </td>
                  <td className="w-1/2 text-center p-0 phone-btn">
                    <a
                      href="tel:(817) 355-3273"
                      className="p-4 flex flex-col items-center justify-center cursor-pointer  border-t-0"
                    >
                      <p className="block text-xs">Call</p>
                      <p>D&M Fort Worth</p>
                    </a>
                  </td>
                </tr>
                <tr className="bottom">
                  <td className="w-1/2 text-center p-0 phone-btn">
                    <a
                      href="tel:713-290-1000"
                      className="p-4 flex flex-col items-center justify-center  cursor-pointer border-b-0"
                    >
                      <p className="block text-xs">Call</p>
                      <p>D&M Houston</p>
                    </a>
                  </td>
                  <td className="w-1/2 text-center p-0 phone-btn">
                    <a
                      href="tel:888-365-3273"
                      className=" p-4 flex flex-col items-center justify-center  cursor-pointer  border-b-0"
                    >
                      <p className="block text-xs">Call</p>
                      <p>D&M Grand Prairie</p>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            type="button"
            onClick={() => setIsPhoneDropdownOpen(false)}
            style={{ borderColor: '#979797' }}
            className="py-4 flex items-center justify-center gap-x-2 w-full"
          >
            <X />
            Close
          </button>
        </div>
      )}
    </nav>
  )
}

export default Navbar
